<template>
  <div>
    <div v-for="arr in listArr" :key="arr" :class="`${mobile ? '' : 'pc_or_tablet mx-auto'}`">
      <Collection :collection="list[arr]" />
    </div>
  </div>
</template>

<script>
import Collection from "@/components/shop/collections/Collection.vue";

export default {
  components: {
    Collection
  },
  async created() {
    await this.$store.dispatch("Collection/getCollections");
  },
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.xs;
    },
    list() {
      return this.$store.state.Collection.list;
    },
    listArr() {
      return this.$store.state.Collection.listArr;
    }
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
.pc_or_tablet {
  width: 500px;
}
</style>
